import React from 'react';
import UserSidebar from './UserSidebar';

export default function UserLayout({ children }) {
  return (
    <div className="flex h-[calc(100vh-var(--preprod-banner-height,0px))] bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <UserSidebar />
      
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <main className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          {children}
        </main>
      </div>
    </div>
  );
}
